import {Directive, forwardRef, Inject} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {Iban, IbanFormatter, isValidIban} from '@atlas/businesstypes';

import {
  ATLAS_VALUE_ACCESSOR,
  AtlasControlValueAccessor,
  BaseBusinesstypeDirective,
} from '../base/index';

/**
 * @ngModule BusinessTypesModule
 */
@Directive({
  selector: '[atlasIban]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => IbanDirective),
    },
  ],
})
export class IbanDirective extends BaseBusinesstypeDirective {
  public constructor(@Inject(ATLAS_VALUE_ACCESSOR) input: AtlasControlValueAccessor) {
    super(input);
  }

  public writeValue(value?: Iban | string): void {
    this._input.writeValue(
      Iban.isIban(value) ? IbanFormatter.format(value) : value == null ? '' : value,
    );
  }

  public registerOnChange(fn: (_: Iban | string | null) => void): void {
    this._input.registerOnChange(value => {
      if (value === '') {
        fn(null);
        return;
      }

      const unformatted = IbanFormatter.unformat(value);
      fn(isValidIban(unformatted) ? new Iban(unformatted) : unformatted);
    });
  }
}
